module.exports = __webpack_public_path__ + "img/09.4c21f4f7.png";